<div class="modal-header">
    <button type="button" class="close" data-dismiss="modal">×</button>
    <h4 class="modal-title">{{TR "Werte anzeigen"}}</h4>
</div>

<div class="modal-body">
    {{#if isLoading}}
    {{TR "Gerätedaten werden geladen."}} <i class="fa fa-spin fa-spinner"></i>
    {{else}}
    {{#if hasDevices}}
    <div class="row m-b-5">
        {{#each columns}}
        <div class="col-xs-5 col-sm-5 col-lg-3">
            {{#SELECT this}}
            <select class="selectpicker js-column m-b-5" data-style="btn-white btn-sm">
                <option value="">{{#if this.length}}-- {{TR "ausblenden"}} --{{else}}--{{/if}}</option>
                {{#each ../datacolumns}}
                <optgroup label="{{name}}">
                    {{#each items}}
                        <option value="{{id}}">{{name}}</option>
                    {{/each}}
                </optgroup>
                {{/each}}
            </select>
            {{/SELECT}}
        </div>
        <div class="col-xs-1 col-sm-1 col-lg-1 p-l-0">
            <div id="column-{{@index}}" class="btn btn-white btn-sm pull-left js-delete-column" {{#if @last}}disabled{{/if}}><i class="fa fa-trash"></i></div>
        </div>
        {{/each}}
        <div class="col-xs-12"><hr></div>
    </div>
    <div class="dataTable"></div>
    {{else}}
    <div class="alert alert-info m-t-20">{{TR "Im gewählten Bereich sind keine Geräte vorhanden."}}</div>
    {{/if}}
    {{/if}}
</div>

<div class="modal-footer">
    {{#if hasDevices}}
    <button id="js-config" class="btn btn-white pull-left" data-dismiss="modal" {{#if noSelection}}disabled{{/if}}>
       <i class="fa fa-cloud-upload m-r-10"></i>{{TR "Werte auswählen"}}
    </button>
    <button id="js-write" class="btn btn-white pull-left" data-dismiss="modal" {{#if noSelection}}disabled{{/if}}>
        <i class="glyphicon glyphicon-pencil m-r-10"></i>{{TR "Wert schreiben"}}
    </button>
    {{/if}}
    <button id="ct-cancel" class="btn btn-white" data-dismiss="modal">
        {{TR "Schließen"}}
    </button>
</div>
